<template>
    <div class="aba-formulario">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissao.create && !assFormularioIntegracao && !formularioIntegracao
                            ? 'is-4'
                            : permissao.create && !assFormularioIntegracao && formularioIntegracao
                            ? 'is-6'
                            : !formularioIntegracao && (permissao.create || assFormularioIntegracao)
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-formulario"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissao.create && !assFormularioIntegracao && !formularioIntegracao
                            ? 'is-2'
                            : permissao.create && !assFormularioIntegracao && formularioIntegracao
                            ? 'is-3'
                            : !formularioIntegracao && (permissao.create || assFormularioIntegracao)
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div class="column is-3" v-if="!assFormularioIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalFormulariosNaoAssociados"
                    >
                        {{ $t('vincular-formulario') }}
                    </button>
                </div>
                <div class="column is-3" v-if="!formularioIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-formulario-new',
                                query: {
                                    tela: 'ven-motivo-atendimento-edit',
                                    id: $route.params.id,
                                    descricao: $route.params.descricao,
                                    isAssociated: true,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-formulario') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assMotivoAtendimentoFormulario"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'titulo'">
                            <a @click="showModalEdicaoFormulario(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key == 'obrigatorio'">
                            {{ $t(props.row['obrigatorio'] ? 'sim' : 'nao') }}
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assFormularioIntegracao"
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <FormularioModal @fecharModal="fecharModal" />
                </div>
            </b-modal>
            <!-- MODAL DE EDICAO -->
            <b-modal :active.sync="showModalEdicao">
                <div class="bg">
                    <EditarFormularioModal
                        :selected="assMotivoAtendimentoformularioSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import FormFormularioService from '@/services/AssMotivoAtendimentoFormFormularioService';
import FormularioModal from '@/components/vendas/motivo-atendimento/modal/FormularioModal.vue';
import EditarFormularioModal from '@/components/vendas/motivo-atendimento/modal/EditarFormularioModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        FormularioModal,
        EditarFormularioModal,
    },
    data() {
        return {
            assFormularioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CRM_ATENDIMENTO_FORMULARIO'
            ),
            formularioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('FORMULARIO'),
            assMotivoAtendimentoFormulario: [],
            fields: [
                { key: 'codigo', width: '7.5%', sortable: true, sortFn: null },
                { key: 'titulo', width: null, sortable: true, sortFn: null },
                { key: 'obrigatorio', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new FormFormularioService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            assMotivoAtendimentoformularioSelected: null,
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'titulo',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            showModalEdicao: false,
            userSelfUpdate: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-motivo-atendimento');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-motivo-atendimento' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.$route.params.id,
                    'crm_motivo_atendimento',
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assMotivoAtendimentoFormulario = value;
                    this.isEmpty = this.assMotivoAtendimentoFormulario.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar formularios.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((ass) => {
                return {
                    codigo: ass.formFormulario.idform_formularioerp,
                    id: ass.id,
                    titulo: ass.formFormulario.titulo,
                    situacao: ass.situacao,
                    obrigatorio: ass.obrigatorio,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.titulo }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-reativar-associacao-formulario'
                    : 'msg-erro-ao-desativar-associacao-formulario';

            let tempAssMotivoAtendimentoFormulario = {
                id: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAssMotivoAtendimentoFormulario)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-formulario'
                                : 'msg-sucesso-ao-desativar-associacao-formulario';
                        this.$root.showMessage('success', tempSuccess);

                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalEdicaoFormulario(item) {
            this.assMotivoAtendimentoformularioSelected = item;
            this.showModalEdicao = !this.showModalEdicao;
        },
        showModalFormulariosNaoAssociados() {
            this.assMotivoAtendimentoformularioSelected = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.showModalEdicao = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-formulario {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
